// extracted by mini-css-extract-plugin
export default {"login_card":"LoginPage_login_card__GcfmN","login_button":"LoginPage_login_button__WvNpJ"};